class subscriptionHelpOffreEte2018Ctrl {
    /** @ngInject */
    constructor(ContactTelephone) {
        this.ContactTelephone = ContactTelephone
    }

    offerContactTelephone() {
        const offer = this.contractDraft.utm_campaign === 'offre-ete-selectra' ? 'offreEte2018Selectra' : 'offreEte2018Plum'
        return this.ContactTelephone[offer]
    }
}

export default {
    template: require('./subscriptionHelpOffreEte2018.jade')(),
    controller: subscriptionHelpOffreEte2018Ctrl,
    bindings: {
        contractDraft: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/subscription/component/subscriptionHelpOffreEte2018.js